const schemaModules = import.meta.glob<{ default: () => Record<string, unknown> }>(
  '../../runtime-*/src/validation/schema.ts',
  { eager: false }
)
const helpModules = import.meta.glob<{ default: () => string }>('../../runtime-*/src/documentation/help.ts', {
  eager: false,
})

const loadLocalRuntimeMetadata = async (
  kind: string
): Promise<{ getPayloadSchema?: () => Record<string, unknown>; getDocumentation?: () => string }> => {
  const k = kind.toLowerCase()
  const schemaKey = `../../runtime-${k}/src/validation/schema.ts`
  const helpKey = `../../runtime-${k}/src/documentation/help.ts`

  const [schemaMod, helpMod] = await Promise.all([schemaModules[schemaKey]?.(), helpModules[helpKey]?.()])

  return {
    getPayloadSchema: schemaMod?.default,
    getDocumentation: helpMod?.default,
  }
}

export default loadLocalRuntimeMetadata
